<template>
  <div id="app" :data-page="page">
    <VideoControl
      v-if="videoContentSource"
      ref="contentControl"
      :source="videoContentSource"
      @onEnded="onEnded"
    />

    <template v-if="loaded">
      <SplashScreen
        v-if="page === 'SplashScreen'"
        @action="onAction"
      />
      <PresentationScreen
        v-else
        ref="presentationScreen"
        @action="onAction"
      />
    </template>

    <div :class="[ 'header', headerColor ]">
      <div class="logo"></div>

      <nav>
        <div class="icon icon-home" @click="reset"></div>
        <div class="icon icon-molecule" @click="gotoMenu"></div>
        <div class="icon icon-references" @click="showReferencesPopup"></div>
      </nav>
    </div>

    <PopupReferences v-if="showReferences" @dismiss="hideReferencesPopup" />
  </div>
</template>

<script>
import PopupReferences from './components/partials/PopupReferences.vue'
import PresentationScreen from './components/pages/PresentationScreen.vue'
import SplashScreen from './components/pages/SplashScreen.vue'
import VideoControl from './components/partials/VideoControl.vue'

export default {
  name: 'App',
  components: {
    PopupReferences,
    PresentationScreen,
    SplashScreen,
    VideoControl,
  },
  data() {
    return {
      loaded: false,
      page: 'SplashScreen',
      headerColor: '',
      showReferences: false,
      videoContentSource: null,

      eventHandlers: {
        'navigate': this.navigate,
        'playChapter': this.playChapter,
        'updateHeader': this.updateHeader,
        'writeAnalytics': this.writeAnalytics,
      },
      onEndedCallback: null,
    }
  },
  methods: {
    onAction(event) {
      if (event.type in this.eventHandlers) {
        this.eventHandlers[event.type](event);
      }
    },
    onLoaded() {
      this.videoContentSource = this.$store.getters.video('main');
      this.loaded = true;
    },

    // Event handlers
    reset() {
      if (this.page === 'PresentationScreen') {
        this.$refs['contentControl'].pause();
        this.$refs['presentationScreen'].reset();
      }
      this.$store.commit('SetReferenceGroup', 0);
      this.page = 'SplashScreen';
      this.headerColor = '';
    },
    navigate(event) {
      if (this.page === 'SplashScreen' && event.data !== this.page) {
        this.$store.dispatch('NewSession');
        this.writeAnalytics({ data: 'Begin Session' });
      }
      this.page = event.data;
    },
    playChapter(event) {
      this.$refs['contentControl'].playChapter(event.data.chapter);
      this.onEndedCallback = event.data.onEnded || null;
    },
    onEnded() {
      if (this.onEndedCallback) {
        this.onEndedCallback();
      }
    },
    showReferencesPopup() {
      this.$refs['contentControl'].pause();
      if (this.page === 'PresentationScreen') {
        this.$refs['presentationScreen'].pauseVideo();
      }
      this.showReferences = true;
    },
    hideReferencesPopup() {
      this.showReferences = false;
      this.$refs['contentControl'].resume();
      if (this.page === 'PresentationScreen') {
        this.$refs['presentationScreen'].resumeVideo();
      }
    },
    updateHeader(event) {
      this.headerColor = event.data;
    },
    gotoMenu() {
      if (this.page === 'SplashScreen') {
        this.$store.dispatch('NewSession');
        this.writeAnalytics({ data: 'Begin Session' });
      }
      if (this.page !== 'PresentationScreen') {
        this.page = 'PresentationScreen';
      }
      this.$store.commit('SetReferenceGroup', 0);

      setTimeout(() => {
        this.$refs['presentationScreen'].onAction({ type: 'gotoSection', data: 8 });
      }, 100);
    },

    writeAnalytics(event) {
      if (window.writeAnalytics) {
        const now = new Date();
        const session = this.$store.getters.session;
        const entry = `${now.toLocaleDateString()},${now.toLocaleTimeString()},${session},${event.data}\n`;
        window.writeAnalytics(entry);
      }
    },
  },
  created() {
    this.$importConfig('static/config.json', () => this.onLoaded());
  },
}
</script>

<style lang="scss">
@import './scss/app.scss';
</style>
